import { config as cargoOwnerShareAccessConfig } from "components/shared/cargoOwnerShareAccess/config";
import { counterpartyStatuses } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { list as counterpartyGroups } from "sources/books/counterpartyGroups";

const config = {
    name: {
        // field
        label: "Имя",
        inputProps: { name: "name" },
        validators: [requiredField],
        required: true,
    },
    isForeign: {
        label: "Иностранный контрагент",
        inputProps: { name: "isForeign" },
        checkbox: true,
        type: "checkbox",
    },
    inn: {
        // field
        label: "ИНН",
        inputProps: { name: "inn" },
        validators: [requiredField],
        required: true,
    },
    kpp: {
        // field
        label: "КПП",
        inputProps: { name: "kpp" },
        nullable: true,
    },
    ogrn: {
        label: "ОГРН",
        inputProps: { name: "ogrn" },
        nullable: true,
    },
    address: {
        label: "Юридический адрес",
        inputProps: { name: "address" },
        textarea: true,
        nullable: true,
    },
    city: {
        label: "Город",
        inputProps: { name: "city" },
        nullable: true,
    },
    street: {
        label: "Улица",
        inputProps: { name: "street" },
        nullable: true,
    },
    houseNumber: {
        label: "Дом",
        inputProps: { name: "houseNumber" },
        nullable: true,
    },
    bankId: {
        label: "БИК",
        inputProps: { name: "bankId" },
        nullable: true,
    },
    bankName: {
        label: "Банк",
        inputProps: { name: "bankName" },
        nullable: true,
    },
    correspondentAccount: {
        label: "Корреспондентский счет",
        inputProps: { name: "correspondentAccount" },
        nullable: true,
    },
    settlementAccount: {
        label: "Расчетный счет",
        inputProps: { name: "settlementAccount" },
        nullable: true,
    },
    counterpartyGroupId: {
        // select
        label: "Группа",
        inputProps: { name: "counterpartyGroupId" },
        url: counterpartyGroups,
        propName: "name",
        menuPortalTarget: document.body,
        alwaysEnabled: true,
    },
    status: {
        // status
        label: "Статус",
        inputProps: { name: "status" },
        options: counterpartyStatuses,
        menuPortalTarget: document.body,
        unClearable: true,
    },
    analyzeStrictOffsetHours: {
        label: "Период анализа посещения точек",
        inputProps: {
            name: "analyzeStrictOffsetHours",
            type: "number",
            step: "1",
            placeholder: "От 12 до 96",
            min: 12,
            max: 96,
        },
        fieldWrapper: "col-3",
    },
    mailingAddress: {
        label: "Почтовый адрес контрагента",
        inputProps: { name: "mailingAddress" },
        textarea: true,
        nullable: true,
    },
    comment: {
        label: "Комментарий",
        inputProps: { name: "comment" },
        textarea: true,
    },
    isInsolvent: {
        label: "Неплатежеспособный",
        inputProps: { name: "isInsolvent" },
        checkbox: true,
        alwaysEnabled: true,
    },
    insolvencyComment: {
        label: "Комментарий к статусу неплатежеспособности",
        inputProps: { name: "insolvencyComment" },
        textarea: true,
        alwaysEnabled: true,
        validators: [(value, data) => (data.isInsolvent ? requiredField(value) : "")],
    },
    noteForDrivers: {
        label: "Примечание для водителей",
        inputProps: { name: "noteForDrivers" },
        textarea: true,
    },
    management: {
        value: {},
        config: {
            position: {
                label: "Должность",
                inputProps: { name: "position" },
            },
            lastName: {
                label: "Фамилия",
                inputProps: { name: "lastName" },
            },
            firstName: {
                label: "Имя",
                inputProps: { name: "firstName" },
            },
            patronymic: {
                label: "Отчество",
                inputProps: { name: "patronymic" },
            },
        },
    },
    contactPerson: cargoOwnerShareAccessConfig.contactPerson,
    documents: {},
    documentTemplates: {},
    platforms: { value: [] },
};

const shareConfig = {
    email: {
        label: "Email",
        inputProps: { name: "email" },
        validators: [requiredField],
        required: true,
    },
};

const shareInitialState = getInitialStateFromConfig(shareConfig);
const initialState = getInitialStateFromConfig(config);

export { config, initialState, shareConfig, shareInitialState };
